import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Job Position',
    dataIndex: 'job_position',
    key: 'job_position',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/employee-app/employees/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

const periods = [{value: 'years', label: 'Year(s)'}, {value: 'months', label: 'Month(s)'}, {value: 'week', label: 'Week(s)'}];


const Employees = () => {
  const employees = useLoaderData();
  const navigate = useNavigate();


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/employee-app/employees/'+record.seo)
    };
  }

  return (
    <div> 
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Employees</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/employee-app/employees/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={employees}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default Employees;